import { Component, OnInit, } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ProvidermaintenanceDialogComponent } from './providermaintenance-dialog/providermaintenance-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ToastrService } from 'ngx-toastr';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { BillingService } from 'src/app/Services/AdminConfigurations/billing.service';
import { IInsuranceCarriers } from 'src/app/models/IInsuranceCarriers';
import { IClaimCodeMaster } from 'src/app/models/IClaimCodeMaster';
import { IProviderIdentities } from 'src/app/models/IProviderIdentities';
import { warningDialogModel, WarningDialogComponent } from 'src/app/ChildControls/warning-dialog/warning-dialog.component';
import { Defaults } from 'src/app/Utilities/defaults';



// export interface Food {
//   value: string;
//   viewValue: string;
// }

// export interface PeriodicElement {
//   payer: string;
//   IDType: string;
//   ID: string;
//   Taxonomy: string;
//   Action: string;


// }

// const ELEMENT_DATA: PeriodicElement[] = [
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' },
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' },
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' },
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' },
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' },
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' },
//   { payer: 'ADHOC TESTING', IDType: 'ADHOC 135', ID: 'True', Taxonomy: 'ADHOC TESTING', Action: '' }


// ];


@Component({
  selector: 'app-providermaintenance',
  templateUrl: './providermaintenance.component.html',
  styleUrls: ['./providermaintenance.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})

export class ProvidermaintenanceComponent implements OnInit {
  columnsToDisplay = ['payer', 'idType', 'id', 'taxonomy', 'Action'];
  headercolumnsToDisplay = ['Payer', 'ID Type', 'ID', 'Taxonomy', 'Action'];
  // dataSource = ELEMENT_DATA;
  expandedElement: IProviderIdentities | null;
  LoadPayerdetails: IProviderIdentities[] = [];
  // dataSource = new MatTableDataSource(this.LoadPayerdetails);
  public lstProviderSource: IUserDetails[];
  public providerdetailById: IUserDetails;
  userPayerDetails: IProviderIdentities;
  userPayerIdentityDetails: IProviderIdentities;
  PayerIdentityId = 0;


  // foods: Food[] = [
  //   { value: 'steak-0', viewValue: 'Steak' },
  //   { value: 'pizza-1', viewValue: 'Pizza' },
  //   { value: 'tacos-2', viewValue: 'Tacos' }
  // ];

  public show: boolean = false;
  public result: any;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
    this.clearPayerIdentities();
  }


  providermaintenanceform: FormGroup;
  submitted = false;
  isRenderingProvider: boolean = false;
  getuserid: string = '';
  public lstPayerName: IInsuranceCarriers[];
  public claimCodeIdTypes: IClaimCodeMaster[] = [];
  public delEmgContact: string = "";

  constructor(
    //private app: AppComponent,
    private fb: FormBuilder
    , private route: ActivatedRoute
    , private billingService: BillingService
    , private router: Router
    , public dialog: MatDialog
    , private sharedService: SharedService
    , private toastr: ToastrService
  ) {
    // app.isLoggedIn$ = true;
  }

  formErrors = {
    'selprovider': '',
    'fname': '',
    'lname': '',
    // 'ssno': '',
  };

  validationMessages = {
    'selprovider': {
      'required': 'Provider is required.',
    },
    'fname': {
      'required': 'First Name is required.'
    },
    'lname': {
      'required': 'Last Name is required.'
    },
    // 'ssno': {
    //   'required': 'SSN is required.',
    // },
  };

  ngOnInit() {
    this.providermaintenanceform = this.fb.group({
      selprovider: ['', Validators.required],
      rendering: ['',],
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      midname: ['',],
      deanum: ['',],
      ssno: ['', Validators.required],
      SupervisingProvider: ['',],
      location: ['',],
      email: ['',],
      npi: ['',],
      taxid: ['',],
      taxonomy: ['',],
      provideraprescrib: ['',],
      selaprovider: ['',],
      renderingg: ['',],
      fnames: ['',],
      lnames: ['',],
      midnames: ['',],
      deanumb: ['',],
      ssnum: ['',],
      providersuper: ['',],
      locations: ['',],
      emails: ['',],
      npii: ['',],
      taxidd: ['',],
      taxonomyy: ['',],
      providerapres: ['',],
      insuranceCarrierId: ['',],
      cliamIdType: ['',],
      pmId: ['',],
      pmTaxonomy: ['',],

    });

    this.userPayerIdentityDetails = {
      payerId: null,
      payer: '',
      idType: '',
      id: '',
      taxonomy: '',
      userId: '',
      isActive: null,
      createdBy: '',
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      dbOperation: '',
      insuranceCode: '',
      insuranceId: '',
      idTypeId: '',
    };

    this.ProviderDropdownBindings();
    this.providermaintenanceform.markAllAsTouched();
    this.providermaintenanceform.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.providermaintenanceform);
    });
  }


  ProviderDropdownBindings() {

    this.sharedService.getAllUsersByRole(Defaults.doctorType).subscribe(data => {
      this.lstProviderSource = data;
    });

    this.billingService.getInsCarriers().subscribe(data => {
      this.lstPayerName = data;
    });

    this.sharedService.getClaimCodes().subscribe(data => {
      this.claimCodeIdTypes = data.filter((attr: IClaimCodeMaster) => attr.attributeType === Defaults.claimCodeIdAttributeType);
    })
  }

  logValidationErrors(group: FormGroup = this.providermaintenanceform): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  ProviderChange(value) {
    this.clearProviderDetails();

    this.billingService.getProviderDetialsByUser(encodeURIComponent(value)).subscribe(data => {
      this.providerdetailById = data;
      if (this.providerdetailById != null) {
        if (this.providerdetailById.userId != null) {
          if (this.providerdetailById.providerType == Defaults.providerType_Rendering) {
            this.isRenderingProvider = true;
          }
          else {
            this.isRenderingProvider = false;
          }

          this.getuserid = value;

          this.providermaintenanceform.patchValue({
            rendering: this.isRenderingProvider,
            fname: this.providerdetailById.firstName,
            lname: this.providerdetailById.lastName,
            midname: this.providerdetailById.middleName,
            deanumb: this.providerdetailById.deaNumber,
            ssno: this.providerdetailById.ssn,
            email: this.providerdetailById.email,
            npi: this.providerdetailById.npiNumber,
            taxonomy: this.providerdetailById.taxonomy,
            taxid: this.providerdetailById.tinNumber,
            provideraprescrib: this.providerdetailById.isPrescriber,
            SupervisingProvider: this.providerdetailById.supervisingProvider,
          });

          this.billingService.getProviderEntityDetialsByUser(encodeURIComponent(this.getuserid)).subscribe(PIdata => {
            this.LoadPayerdetails = PIdata;
          });


        }
        else {
          this.clearProviderDetails();
        }
      }
    });
  }



  clearProviderDetails() {
    this.providermaintenanceform.patchValue({
      // selprovider: null,
      rendering: null,
      fname: '',
      lname: '',
      midname: '',
      deanumb: '',
      ssno: '',
      email: '',
      npi: '',
      taxonomy: '',
      taxid: '',
      provideraprescrib: null,
    });
    this.LoadPayerdetails = null;
  }

  onSubmit(): void {
    if (this.getuserid != null) {

      this.providerdetailById.userId = encodeURIComponent(this.getuserid);
      this.mapFormValuesToUserModel();
      if (this.providerdetailById.userId) {
        this.billingService.updateProviderDetails(this.providerdetailById).subscribe((results: any) => {
          this.result = results;
          this.show = false; this.expandedElement = null;
          // this.getAlertsInfo(CommonComponents.patientId);
          this.clearProviderDetails();
          this.getuserid = null;
          this.toastr.success(this.result);
        });
      }
    }
  }

  mapFormValuesToUserModel() {

    this.isRenderingProvider = this.providermaintenanceform.value.rendering;
    if (this.isRenderingProvider == true) {
      this.providerdetailById.providerType = Defaults.providerType_Rendering;
    }
    else {
      this.providerdetailById.providerType = null;
    }

    this.providerdetailById.firstName = this.providermaintenanceform.value.fname;
    this.providerdetailById.lastName = this.providermaintenanceform.value.lname;
    this.providerdetailById.middleName = this.providermaintenanceform.value.midname;
    this.providerdetailById.deaNumber = this.providermaintenanceform.value.deanumb;
    this.providerdetailById.ssn = this.providermaintenanceform.value.ssno;
    this.providerdetailById.email = this.providermaintenanceform.value.email;
    this.providerdetailById.npiNumber = this.providermaintenanceform.value.npi;
    this.providerdetailById.taxonomy = this.providermaintenanceform.value.taxonomy;
    this.providerdetailById.tinNumber = this.providermaintenanceform.value.taxid;
    this.providerdetailById.isPrescriber = this.providermaintenanceform.value.provideraprescrib;
    this.providerdetailById.supervisingProvider = this.providermaintenanceform.value.SupervisingProvider;
    this.providerdetailById.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
  }

  openDialog() {
    const dialogRef = this.dialog.open(ProvidermaintenanceDialogComponent, {
      width: '400px',
      data: { headerText: "Please enter a value" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) { }
    });
  }

  onPayerSubmit(id): void {
    if (id != null) {

      this.userPayerIdentityDetails.payerId = id;
      this.mapFormValuesToPayerModel();
      if (this.userPayerIdentityDetails.payerId != null) {
        this.billingService.updateProviderEntityDetails(this.userPayerIdentityDetails).subscribe((results: any) => {
          this.result = results;
          this.show = false; this.expandedElement = null;
          this.PayerIdentityId = 0;
          this.billingService.getProviderEntityDetialsByUser(encodeURIComponent(this.getuserid)).subscribe(PIdata => {
            this.LoadPayerdetails = PIdata;
          });
          this.toastr.success(this.result);
        });
      }
    }
    else {
      const message = ' UserId required';
      const dialogData = new warningDialogModel('Alert !', message);
      const dialogRef = this.dialog.open(WarningDialogComponent, {
        maxWidth: '400px',
        height: '120px',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(dialogResult => {
        this.result = dialogResult;
      });
    }
  }

  mapFormValuesToPayerModel() {

    this.userPayerIdentityDetails.userId = this.getuserid;
    this.userPayerIdentityDetails.insuranceId = this.providermaintenanceform.value.insuranceCarrierId;
    this.userPayerIdentityDetails.idTypeId = this.providermaintenanceform.value.cliamIdType;
    this.userPayerIdentityDetails.id = this.providermaintenanceform.value.pmId;
    this.userPayerIdentityDetails.taxonomy = this.providermaintenanceform.value.pmTaxonomy;
    this.userPayerIdentityDetails.isActive = Defaults.active;
    this.userPayerIdentityDetails.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    if (this.PayerIdentityId != 0) {
      this.userPayerIdentityDetails.dbOperation = 'Update';
    }
    else
      this.userPayerIdentityDetails.dbOperation = 'Insert';
  }

  clearPayerIdentities() {
    this.providermaintenanceform.patchValue({

      insuranceCarrierId: null,
      cliamIdType: '',
      pmId: '',
      pmTaxonomy: '',
    });
  }



  oncellclick(element: IProviderIdentities) {

    if (this.delEmgContact === "delete") {
      this.expandedElement = null
    } else {
      this.providermaintenanceform.patchValue({
        insuranceCarrierId: element.insuranceId,
        cliamIdType: element.idTypeId,
        pmId: element.id,
        pmTaxonomy: element.taxonomy,
      });
      this.PayerIdentityId = element.payerId;
    }
  }

  onCancelClick() {
    this.clearProviderDetails();
  }

  onPayerCancelClick() {
    this.clearPayerIdentities();
  }

  deletePayerIdentityContact(element: IProviderIdentities, delNo: string) {

  }

}

